'use strict';

(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.dlaRandomizeOrder = {
    attach: function attach(context, settings) {

      // $(context).find('[data-dla-randomize-order]').once().each(function () {
      $(once('dla-processed', '[data-dla-randomize-order]', context)).each(function () {
        var parent = $(this).find('.' + $(this)[0].attributes[0].nodeValue).parent();
        var divs = $(this).find('.' + $(this)[0].attributes[0].nodeValue);
        while (divs.length) {
          parent.append(divs.splice(Math.floor(Math.random() * divs.length), 1)[0]);
        }
        $(this).show();
      });

    }
  };

})(jQuery, Drupal, once);
